// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-raised-button.mat-blue {
  background-color: #5479b9;
  color: white;
}

.mat-mdc-raised-button.mat-gray {
  background-color: #c7c7c7;
  color: white;
}

ul {
  padding: 0;
}
ul li {
  list-style-type: none;
}

.body {
  max-height: calc(100vh - 30rem);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/email-preview-modal/email-preview-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;AACF;AACE;EACE,qBAAA;AACJ;;AAGA;EACE,+BAAA;EACA,cAAA;AAAF","sourcesContent":[".mat-mdc-raised-button.mat-blue {\r\n  background-color: #5479b9;\r\n  color: white;\r\n}\r\n\r\n.mat-mdc-raised-button.mat-gray {\r\n  background-color: #c7c7c7;\r\n  color: white;\r\n}\r\n\r\nul {\r\n  padding: 0;\r\n\r\n  li {\r\n    list-style-type: none;\r\n  }\r\n}\r\n\r\n.body {\r\n  max-height: calc(100vh - 30rem);\r\n  overflow: auto;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
